<div>
  <mat-checkbox (change)="setLinear()" [checked]="testService.linear">Linjär
  </mat-checkbox>
</div>
